/* eslint-disable no-nested-ternary */
import {
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonImg,
  IonText,
  IonTitle,
} from '@ionic/react';
import React from 'react';

import AppelPay from '@/assets/imgs/apple-pay.webp';
import BelenderLoginImg from '@/assets/imgs/belender/belenderLogin.webp';
import CounterOfferLoginImg from '@/assets/imgs/login/loginCounterOffer.webp';
import PepperAlwaysYesImg from '@/assets/imgs/login/pepper-always-yes.webp';
import GooglePay from '@/assets/imgs/google-pay.webp';
import useMediaQuery, { Breakpoint } from '@/hooks/useMediaQuery';
import LoginAd from '@/pages/Login/LoginAd/LoginAd';
import { BELENDER_EXPIRATION, COUNTER_OFFER_EXPIRATION, GREEN_CARD_EXPIRATION } from '@/constants';

import styles from './LoginScreen.module.scss';

export default function LoginScreen() {
  const isDesktopLarge = useMediaQuery(Breakpoint.DesktopLarge);

  return (
    <IonCard className={styles.loginScreenCard} id="login-screen-card">
      {BELENDER_EXPIRATION ? (
        <IonCardContent className={styles.contentBelender}>
          <IonImg src={BelenderLoginImg} />
        </IonCardContent>
      ) : COUNTER_OFFER_EXPIRATION ? (
        <IonCardContent className={styles.counterOfferContent}>
          <IonImg src={CounterOfferLoginImg} />
        </IonCardContent>
      ) : GREEN_CARD_EXPIRATION ? (
        <IonCardContent>
          <IonImg src={PepperAlwaysYesImg} />
        </IonCardContent>
      ) : (
        <>
          <IonCardHeader mode="md">
            <IonCardTitle>
              <IonTitle className={styles.textLoginNovedad}>¡Novedad!</IonTitle>
              <IonTitle className={styles.textLoginBasic}>
                <span className={styles.textLoginBasic}>Ahora tu cliente puede</span>
                <span className={styles.textLoginBasic}>terminar la financiación</span>
                <span className={styles.textLoginBasic}>con wallet</span>
              </IonTitle>
            </IonCardTitle>
          </IonCardHeader>
          <IonCardContent className={styles.contentInfo}>
            <div className={styles.contentInfo}>
              <IonImg className={styles.webpImg} src={GooglePay} />
              <IonImg className={styles.webpImg} src={AppelPay} />
            </div>
          </IonCardContent>
          {!isDesktopLarge
            && (
              <IonCardContent className={styles.loginScreenFooter}>
                <IonText className={styles.contentFooterText}>
                  Las mejores tarifas en la App
                </IonText>
                <IonText className={styles.contentFooterTextApp}>Pepper Comercios</IonText>
                <LoginAd />
              </IonCardContent>
            )}
        </>
      )}
    </IonCard>

  );
}
